import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../auth.store';
import useNavigateWithParams from '../../../hooks/useNavigateWithParams';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

/**
 * Guard component for routes that require authentication.
 * Redirects unauthenticated users to the login page, preserving the requested URL
 * as a 'returnUrl' parameter and keeping important global parameters like 'language'.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { accessToken, customer } = useAuthStore();
    const location = useLocation();
    const navigate = useNavigateWithParams();

    const isAuthenticated = !!(accessToken && customer);

    useEffect(() => {
        if (!isAuthenticated) {
            const currentPath = location.pathname + location.search;
            navigate(`/auth/login?returnUrl=${encodeURIComponent(currentPath)}`, { replace: true });
        }
    }, [isAuthenticated, location, navigate]);

    if (!isAuthenticated) {
        return null; // Prevent rendering children while redirecting
    }

    return <>{children}</>;
}
